import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Typography, Grid, useMediaQuery } from '@mui/material';
import { displayFlex, fontsize24, poppins400 } from 'theme/common.style';
import { statusCard, statusText } from './StatusLiveCard.style';
import { useTheme } from '@emotion/react';

function StatusLiveCard(props) {
  const {
    cardLogo,
    cardLogoBgColor,
    cardText,
    cardValue,
    cardIndicator,
    onClickCard,
    keyVal,
    isClicked,
    active,
    showclick,
  } = props;
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches360 = useMediaQuery(theme.breakpoints.down(360));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matchesupmd = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <Card
      sx={[statusCard, { cursor: showclick && 'pointer' }]}
      style={{ width: '98.7%', height: '74px', border: '1px solid #F0F0F0' }}
      onClick={() => {
        if (showclick) {
          onClickCard(keyVal);
        }
      }}
    >
      <Grid
        sx={displayFlex}
        style={{
          padding: '10px',
          justifyContent: 'space-between',
          backgroundColor: active == keyVal ? '#F8F8F8' : 'white',
          alignItems: 'center',
          height: '100%',
        }}
      >
        <Grid sx={displayFlex}>
          <Typography
            style={{
              padding: '10px',
              backgroundColor: cardLogoBgColor,
              display: 'flex',
              justifyContent: 'center',
              borderRadius: '5px',
              height: matcheslg ? '34px' : '52px',
              width: matcheslg ? '34px' : '52px',
            }}
          >
            <Typography
              style={{
                display: 'flex',
                'align-items': 'center',
              }}
            >
              <img
                src={cardLogo}
                alt="Live"
                width={matcheslg ? 19 : 28}
                height={matcheslg ? 19 : 28}
              />
            </Typography>
          </Typography>
          <Typography
            sx={{
              fontWeight: matchesupmd ? 400 : 300,
              fontFamily: 'poppins',
              ...displayFlex,
              fontSize: !matcheslg ? '24px' : matches360 ? '18px' : '20px',
              color: '#000000',
            }}
            style={{
              marginLeft: matcheslg ? '15px' : matches360 ? '15px' : '20px',
              alignItems: 'center',
            }}
            whiteSpace={'nowrap'}
          >
            {cardText}
          </Typography>
        </Grid>
        <Grid sx={displayFlex} style={{ alignItems: 'center' }}>
          <Typography sx={statusText}>
            <Typography
              sx={{
                fontWeight: matchesupmd ? 400 : 300,
                fontFamily: 'poppins',
                fontSize: !matcheslg ? '24px' : matches360 ? '18px' : '20px',
                color: '#262626',
              }}
              style={{ paddingRight: '10px' }}
            >
              {cardValue}
            </Typography>
          </Typography>
          <Typography
            sx={displayFlex}
            style={{ width: '25px', height: '25px', alignItems: 'stretch' }}
          >
            {cardIndicator ? (
              <Typography sx={{ display: 'flex', justifyContent: 'right' }}>
                <img src={cardIndicator} alt="Live" />
              </Typography>
            ) : null}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

StatusLiveCard.propTypes = {
  cardLogo: PropTypes.string.isRequired,
  cardLogoBgColor: PropTypes.string.isRequired,
  cardText: PropTypes.string.isRequired,
  cardValue: PropTypes.number.isRequired,
  cardIndicator: PropTypes.string.isRequired,
  onClickCard: PropTypes.func.isRequired,
  keyVal: PropTypes.string.isRequired,
};

export default StatusLiveCard;
